import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import steps from '../../data/steps';

const Stepper = () => {
  const { t } = useTranslation();
  const [currentStep, setCurrentStep] = useState(0);
  const [visibleStepContent, setVisibleStepContent] = useState(0);

  const handleStepClick = (index) => {
    if (window.innerWidth < 768) {
      setVisibleStepContent(visibleStepContent === index ? null : index);
    } else {
      setCurrentStep(index);
    }
  };

  return (
    <div className='flex flex-col justify-center items-center gap-12 w-full'>
      {/* Desktop/Tablet Version */}
      <div className='hidden md:flex flex-col justify-center items-center w-full gap-12'>
        <ul className='flex items-center w-full max-w-6xl'>
          {steps.map((step, index) => (
            <React.Fragment key={step.id}>
              <li
                onClick={() => handleStepClick(index)}
                className={`cursor-pointer ${
                  index === currentStep
                    ? 'text-primary-blue'
                    : 'text-primary-red'
                }`}
              >
                <div className='flex flex-col items-center'>
                  <div
                    className={`flex items-center justify-center text-2xl ${
                      index <= currentStep
                        ? 'text-primary-blue'
                        : 'text-gray-300'
                    }`}
                    title={t(`stepper.stepper_list.${step.id}.title`)}
                  >
                    {step.icon}
                  </div>
                  <span className='mt-6 text-2xl font-medium text-primary-blue'>
                    {t(`stepper.stepper_list.${step.id}.title`)}
                  </span>
                </div>
              </li>
              {index < steps.length - 1 && (
                <li className='flex-auto'>
                  <div
                    className={`h-0.5 ${
                      index < currentStep ? 'bg-primary-red' : 'bg-gray-300'
                    }`}
                  ></div>
                </li>
              )}
            </React.Fragment>
          ))}
        </ul>
        <div className='hidden md:flex items-center justify-center text-center'>
          <AnimatePresence mode="wait">
            <motion.p
              key={currentStep}
              initial={{ y: 10, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: -10, opacity: 0 }}
              transition={{ duration: 0.2 }}
              className='max-w-4xl min-h-20 text-xl font-light text-primary-blue'
            >
              {t(`stepper.stepper_list.${steps[currentStep].id}.description`)}
            </motion.p>
          </AnimatePresence>
        </div>
      </div>

      {/* Mobile Version */}
      <div className='flex md:hidden flex-col justify-center items-center w-full gap-6'>
        {steps.map((step, index) => (
          <div key={step.id} className='w-full'>
            <button
              onClick={() => handleStepClick(index)}
              className={`flex flex-col items-center justify-center px-4 py-3 w-full cursor-pointer ${
                visibleStepContent === index
                  ? 'text-primary-blue border-b-2 border-primary-red'
                  : 'text-primary-blue border-b-2 border-gray-300'
              }`}
            >
              <span className='text-xl font-medium'>{t(`stepper.stepper_list.${step.id}.title`)}</span>
            </button>
            {visibleStepContent === index && (
              <div className='mt-6 text-justify'>
                <motion.p
                  key={index}
                  initial={{ y: 10, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  exit={{ y: -10, opacity: 0 }}
                  transition={{ duration: 0.2 }}
                  className='text-lg font-light text-primary-blue'
                >
                  {t(`stepper.stepper_list.${step.id}.description`)}
                </motion.p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Stepper;